import { PeriodInDays, ServiceStatus, TemplateType } from "@/domain/filter/filterType";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import type { FilterSettings, FilterStore } from "./filterTypes";

const initialState: FilterStore["filters"] = {
  receivableMessageRangeId: undefined,
  periodInDays: PeriodInDays.zero,
  templateType: TemplateType.receivables,
  company: undefined,
  user: undefined,
  conversationToday: false,
  serviceStatus: undefined,
  startAt: null,
  endAt: null,
};

export const useFilter = create<FilterStore>()(
  persist(
    (set, get) => ({
      filters: initialState,

      setFilter: (filter: Partial<FilterSettings>) => {
        set(state => ({
          filters: {
            ...state.filters,
            ...filter,
          },
        }));
      },

      removePeriodInDays: () => {
        set(state => ({
          filters: {
            ...state.filters,
            periodInDays: PeriodInDays.zero,
            startAt: null,
            endAt: null,
          },
        }));
      },

      removeTemplateType: () => {
        set(state => ({
          filters: { ...state.filters, templateType: TemplateType.receivables },
        }));
      },

      removeCompany: () => {
        set(state => ({
          filters: { ...state.filters, company: undefined },
        }));
      },

      removeUser: () => {
        set(state => ({
          filters: { ...state.filters, user: undefined },
        }));
      },

      removeFilter: () => {
        set(state => ({
          filters: { ...state.filters, receivableMessageRangeId: undefined },
        }));
      },

      getParams: () => {
        const state = get();
        return {
          filter: state.filters.receivableMessageRangeId,
          periodInDays: state.filters.periodInDays,
          templateType: state.filters.templateType,
          company: state.filters.company,
          user: state.filters.user,
        };
      },

      clearAll: () => {
        set(state => ({
          filters: {
            ...state.filters,
            periodInDays: PeriodInDays.zero,
            templateType: TemplateType.receivables,
            company: undefined,
            user: undefined,
            receivableMessageRangeId: undefined,
            conversationToday: false,
            serviceStatus: undefined,
            startAt: null,
            endAt: null,
          },
        }));
      }
    }),
    {
      name: "filter-settings",
      partialize: state => ({
        filters: state.filters,
      }),
      // JSON não tem data: `startAt` e `endAt` são gravados como string ISO e
      // voltariam como string, quebrando quem espera `Date` de verdade — o
      // `DateField` chama `toLocaleDateString` no valor e derrubava o painel
      // ao reabrir o filtro depois de um F5.
      storage: createJSONStorage(() => localStorage, {
        reviver: (chave, valor) =>
          (chave === "startAt" || chave === "endAt") && typeof valor === "string"
            ? new Date(valor)
            : valor,
      }),
    }
  )
);
